Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp,
    sizing = _STYLES$useStyles.sizing;
  var _columnMaxWidth = 31.25 * _reactNative.PixelRatio.getFontScale() * _styles.baseSize;
  var _gap = 2.5 * _reactNative.PixelRatio.getFontScale() * _styles.baseSize;
  if (bp.desktop) {
    _gap = 5 * _reactNative.PixelRatio.getFontScale() * _styles.baseSize;
  }
  var container = {
    width: '100%',
    maxWidth: _columnMaxWidth * 2 + _gap,
    alignItems: 'center',
    gap: _gap
  };
  if (bp.desktop) {
    container.flexDirection = 'row';
    container.alignItems = 'flex-start';
    container.justifyContent = 'center';
    container.marginTop = 'auto';
    container.marginBottom = 'auto';
  }
  var _shared = {
    alignItems: 'center',
    width: '100%',
    maxWidth: _columnMaxWidth,
    flexShrink: 1
  };
  var left = Object.assign({}, _shared);
  var right = Object.assign({}, _shared);
  if (_reactNative.Platform.OS === 'web' && bp.desktop) {
    right.position = 'sticky';
    right.top = sizing.topBarHeightDefault;
  }
  var styles = _reactNative.StyleSheet.create({
    container: container,
    left: left,
    right: right
  });
  return {
    styles: styles
  };
};